<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <toolbar
        ref="toolbar"
        :key="toolbarKey"
        :buttonList="buttonList"
        :searchList="searchList"
        @callFunction="callFunction">
      </toolbar>

      <div class="repair-stat-content" v-loading="listLoading">
      <el-card shadow="never" class="overview-card">
        <div slot="header" class="block-title">
          <span>核心概览</span>
        </div>
        <div class="summary-grid">
          <div class="summary-item is-neutral">
            <div class="summary-item__label">总报修</div>
            <div class="summary-item__value">{{ summary.TotalCount || 0 }}</div>
          </div>
          <div class="summary-item is-success">
            <div class="summary-item__label">已完成</div>
            <div class="summary-item__value">{{ summary.CompletedCount || 0 }}</div>
          </div>
          <div class="summary-item is-success">
            <div class="summary-item__label">完成率</div>
            <div class="summary-item__value">{{ formatPercent(summary.CompletedRate) }}</div>
          </div>
          <div class="summary-item is-warning">
            <div class="summary-item__label">有费用单</div>
            <div class="summary-item__value">{{ summary.HasCostCount || 0 }}</div>
          </div>
          <div class="summary-item is-cost">
            <div class="summary-item__label">总维修费</div>
            <div class="summary-item__value">¥ {{ formatAmount(summary.TotalCostAmount) }}</div>
          </div>
          <div class="summary-item is-cost">
            <div class="summary-item__label">平均维修费</div>
            <div class="summary-item__value">¥ {{ formatAmount(summary.AvgCostAmount) }}</div>
          </div>
          <div class="summary-item is-duration">
            <div class="summary-item__label">平均处理时长</div>
            <div class="summary-item__value">{{ formatAmount(summary.AvgRepairHours) }}h</div>
          </div>
        </div>
      </el-card>

      <el-row :gutter="12" class="stat-grid">
        <el-col :span="12">
          <el-card shadow="never" class="panel-card">
            <div slot="header" class="block-title"><span>按故障类型统计</span></div>
            <el-table :data="faultTypeStatsPaged" size="mini" stripe class="stat-detail-like-table">
              <el-table-column label="故障类型" min-width="130">
                <template slot-scope="scope">
                  <el-tag
                    v-if="Number(scope.row.TotalCount) > 0 && getTopRank(faultTypeStats, scope.row, 'TotalCount') <= 3"
                    size="mini"
                    :type="getTopTagType(getTopRank(faultTypeStats, scope.row, 'TotalCount'))"
                    class="top-tag">
                    TOP{{ getTopRank(faultTypeStats, scope.row, 'TotalCount') }}
                  </el-tag>
                  <span>{{ scope.row.FaultTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="TotalCount" label="报修数" min-width="110" align="center"></el-table-column>
              <el-table-column prop="CompletedCount" label="完成数" min-width="110" align="center"></el-table-column>
              <el-table-column label="总维修费" min-width="120" align="center">
                <template slot-scope="scope">¥ {{ formatAmount(scope.row.TotalCostAmount) }}</template>
              </el-table-column>
            </el-table>
            <div v-if="faultTypeStats.length > panelPageSize" class="panel-pagination">
              <el-pagination
                small
                layout="total, prev, pager, next"
                :page-size="panelPageSize"
                :total="faultTypeStats.length"
                :current-page="faultTypePage"
                @current-change="handleFaultTypePageChange" />
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="never" class="panel-card">
            <div slot="header" class="block-title"><span>按维修人员统计</span></div>
            <el-table :data="repairerStatsPaged" size="mini" stripe class="stat-detail-like-table">
              <el-table-column label="维修人员" min-width="130">
                <template slot-scope="scope">
                  <el-tag
                    v-if="Number(scope.row.TotalCount) > 0 && getTopRank(repairerStats, scope.row, 'TotalCount') <= 3"
                    size="mini"
                    :type="getTopTagType(getTopRank(repairerStats, scope.row, 'TotalCount'))"
                    class="top-tag">
                    TOP{{ getTopRank(repairerStats, scope.row, 'TotalCount') }}
                  </el-tag>
                  <span>{{ scope.row.RepairerName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="TotalCount" label="报修数" min-width="110" align="center"></el-table-column>
              <el-table-column prop="CompletedCount" label="完成数" min-width="110" align="center"></el-table-column>
              <el-table-column label="平均时长(h)" min-width="120" align="center">
                <template slot-scope="scope">{{ formatAmount(scope.row.AvgRepairHours) }}</template>
              </el-table-column>
            </el-table>
            <div v-if="repairerStats.length > panelPageSize" class="panel-pagination">
              <el-pagination
                small
                layout="total, prev, pager, next"
                :page-size="panelPageSize"
                :total="repairerStats.length"
                :current-page="repairerStatsPage"
                @current-change="handleRepairerStatsPageChange" />
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-card shadow="never" class="detail-card">
        <div slot="header" class="block-title"><span>报修统计明细</span></div>
        <el-table :data="tableData" stripe :max-height="getAdaptiveMaxHeight(tableData, 420)" class="detail-table">
          <el-table-column prop="FaultTypeName" label="维修内容" min-width="120"></el-table-column>
          <el-table-column prop="RepairContent" label="故障描述" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="CreateTime" label="报修时间" min-width="140"></el-table-column>
          <el-table-column prop="CompleteTime" label="维修时间" min-width="140">
            <template slot-scope="scope">{{ scope.row.CompleteTime || '-' }}</template>
          </el-table-column>
          <el-table-column prop="RepairerName" label="维修人员" min-width="120">
            <template slot-scope="scope">{{ scope.row.RepairerName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="ApplicantName" label="报修人员" min-width="120"></el-table-column>
          <el-table-column label="维修费" min-width="110" align="right">
            <template slot-scope="scope">{{ scope.row.RepairCost != null ? `¥ ${formatAmount(scope.row.RepairCost)}` : '-' }}</template>
          </el-table-column>
          <el-table-column label="状态" min-width="120">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row.Status)" size="mini">
                {{ scope.row.StatusStr || '-' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="DepartmentName" label="学校" min-width="120"></el-table-column>
        </el-table>
        <div v-if="total > 0" class="panel-pagination">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :total="total"
            :current-page="page" />
        </div>
      </el-card>
      </div>
    </section>
  </section>
</template>

<script>
import { getRepairStatistics, exportRepairStatistics, getRepairFaultTypeList } from '../../api/modules/repair';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      toolbarKey: Date.now(),
      searchList: [
        { label: '报修人员', key: 'applicantName', width: '130px' },
        { label: '维修人员', key: 'repairerName', width: '130px' },
        {
          label: '状态',
          key: 'status',
          type: 'select',
          clearable: true,
          initValue: -1,
          width: '140px',
          options: [
            { label: '全部', value: -1 },
            { label: '待初审', value: 0 },
            { label: '待维修', value: 1 },
            { label: '维修处理中', value: 2 },
            { label: '费用审批中', value: 3 },
            { label: '已完成', value: 4 },
            { label: '已驳回', value: 5 },
            { label: '已取消', value: 6 },
            { label: '费用审批驳回', value: 7 }
          ]
        },
        {
          label: '故障类型',
          key: 'faultTypeId',
          type: 'select',
          clearable: true,
          width: '150px',
          options: []
        },
        { label: '报修时间', key: 'dateRange', type: 'daterange', init: false, width: '240px' }
      ],
      filters: {},
      buttonList: [],
      DepartmentId: 0,
      listLoading: false,
      exportLoading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      panelPageSize: 5,
      faultTypePage: 1,
      repairerStatsPage: 1,
      summary: {},
      faultTypeStats: [],
      repairerStats: [],
      tableData: []
    };
  },
  computed: {
    faultTypeStatsPaged() {
      const start = (this.faultTypePage - 1) * this.panelPageSize;
      return (this.faultTypeStats || []).slice(start, start + this.panelPageSize);
    },
    repairerStatsPaged() {
      const start = (this.repairerStatsPage - 1) * this.panelPageSize;
      return (this.repairerStats || []).slice(start, start + this.panelPageSize);
    }
  },
  methods: {
    formatAmount(val) {
      const n = Number(val || 0);
      return Number.isFinite(n) ? n.toFixed(2) : '0.00';
    },
    formatPercent(val) {
      const n = Number(val || 0);
      return `${Number.isFinite(n) ? n.toFixed(2) : '0.00'}%`;
    },
    getTopRank(list, row, key) {
      if (!list || !list.length || !row) return 99;
      const sorted = list
        .map(item => Number(item[key] || 0))
        .sort((a, b) => b - a);
      const value = Number(row[key] || 0);
      const rank = sorted.indexOf(value) + 1;
      return rank > 0 ? rank : 99;
    },
    getTopTagType(rank) {
      if (rank === 1) return 'danger';
      if (rank === 2) return 'warning';
      if (rank === 3) return '';
      return 'info';
    },
    getStatusTagType(status) {
      const map = { 0: 'warning', 1: 'info', 2: '', 3: 'warning', 4: 'success', 5: 'danger', 6: 'info', 7: 'danger' };
      return map[status] != null ? map[status] : 'info';
    },
    getAdaptiveMaxHeight(list, maxHeight) {
      return Array.isArray(list) && list.length > 0 ? maxHeight : null;
    },
    buildParams() {
      const f = this.filters || {};
      return {
        departmentId: this.DepartmentId,
        applicantName: f.applicantName || '',
        repairerName: f.repairerName || '',
        status: f.status !== undefined && f.status !== null && f.status !== '' ? f.status : -1,
        faultTypeId: f.faultTypeId || 0,
        startTime: f.dateRange && f.dateRange[0] ? f.dateRange[0] : null,
        endTime: f.dateRange && f.dateRange[1] ? f.dateRange[1] : null,
        page: this.page,
        intPageSize: this.pageSize
      };
    },
    handleQuery() {
      if (!this.DepartmentId) {
        this.$message.warning('请先选择学校');
        return;
      }
      this.listLoading = true;
      getRepairStatistics(this.buildParams()).then(res => {
        this.listLoading = false;
        if (res.data && res.data.success && res.data.response) {
          const response = res.data.response;
          this.summary = response.Summary || {};
          this.faultTypeStats = response.FaultTypeStats || [];
          this.repairerStats = response.RepairerStats || [];
          this.faultTypePage = 1;
          this.repairerStatsPage = 1;
          this.tableData = (response.PageData && response.PageData.data) || [];
          this.total = (response.PageData && response.PageData.dataCount) || 0;
        }
      }).catch(() => { this.listLoading = false; });
    },
    async handleExport() {
      if (!this.DepartmentId) {
        this.$message.warning('请先选择学校');
        return;
      }
      try {
        const params = this.buildParams();
        params.page = 1;
        params.intPageSize = 10000;
        const res = await exportRepairStatistics(params);
        if (!res.data || res.data.size === 0) {
          this.$message.error('导出数据为空');
          return;
        }
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const d = new Date();
        const pad = n => String(n).padStart(2, '0');
        link.href = url;
        link.setAttribute('download', `报修统计_${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (e) {
        this.$message.error('导出失败');
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    handleFaultTypePageChange(page) {
      this.faultTypePage = page;
    },
    handleRepairerStatsPageChange(page) {
      this.repairerStatsPage = page;
    },
    callFunction(item) {
      if (typeof item.search === 'object') this.filters = item.search;
      else this.filters = { applicantName: item.search };
      if (item.Func && typeof this[item.Func] === 'function') {
        this[item.Func].apply(this, item);
      }
    },
    treeNodeClick(data) {
      this.DepartmentId = data.value;
      this.page = 1;
      this.loadFaultTypes(data.value);
      this.$nextTick(() => {
        if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
          this.$refs.toolbar.searchObj.faultTypeId = '';
        }
        this.handleQuery();
      });
    },
    loadFaultTypes(departmentId) {
      if (!departmentId) {
        this.updateFaultTypeOptions([]);
        return;
      }
      getRepairFaultTypeList({ departmentId }).then(res => {
        if (res.data && res.data.success) {
          const list = res.data.response || [];
          this.updateFaultTypeOptions(list.map(x => ({ label: x.Name, value: x.Id })));
        }
      });
    },
    updateFaultTypeOptions(options) {
      const idx = this.searchList.findIndex(s => s.key === 'faultTypeId');
      if (idx >= 0) {
        this.$set(this.searchList[idx], 'options', options);
        this.toolbarKey = Date.now();
      }
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (!this.buttonList.some(b => b.Func === 'handleQuery')) {
      this.buttonList.unshift({ name: '查询', Func: 'handleQuery', id: 999 });
    }
    if (!this.buttonList.some(b => b.Func === 'handleExport')) {
      this.buttonList.push({ name: '导出', Func: 'handleExport', id: 998, icon: 'el-icon-download', btnType: 'success' });
    }
  }
};
</script>

<style scoped>
.stat-grid {
  margin-bottom: 14px;
}
.detail-card {
  margin-bottom: 10px;
}
.repair-stat-content {
  position: relative;
}
.overview-card {
  margin: 8px 0 14px;
}
.panel-card {
  border-radius: 8px;
}
.panel-pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.block-title {
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
}
.summary-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 10px;
}
@media (max-width: 1360px) {
  .summary-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (max-width: 960px) {
  .summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.summary-item {
  border: 1px solid #edf1f7;
  border-radius: 8px;
  background: #fafcff;
  padding: 12px 10px;
  text-align: center;
}
.summary-item.is-neutral {
  background: #f7f9fc;
  border-color: #e6ebf2;
}
.summary-item.is-success {
  background: #f3fbf6;
  border-color: #cdebd8;
}
.summary-item.is-success .summary-item__value {
  color: #2f9e5f;
}
.summary-item.is-warning {
  background: #fff8ee;
  border-color: #f3e0bf;
}
.summary-item.is-warning .summary-item__value {
  color: #d48b16;
}
.summary-item.is-cost {
  background: #f3f8ff;
  border-color: #c9ddf8;
}
.summary-item.is-cost .summary-item__value {
  color: #2f6fed;
}
.summary-item.is-duration {
  background: #f7f4ff;
  border-color: #d8ccf5;
}
.summary-item.is-duration .summary-item__value {
  color: #7a5af8;
}
.summary-item__label {
  color: #8c98a8;
  font-size: 12px;
  margin-bottom: 6px;
}
.summary-item__value {
  color: #1f2d3d;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
}
.top-tag {
  margin-right: 6px;
}
.stat-detail-like-table >>> .cell {
  white-space: nowrap;
}
.stat-detail-like-table >>> .el-table__header th {
  background: #f7f9fc;
  color: #3a4a5e;
  font-size: 13px;
  font-weight: 600;
}
.stat-detail-like-table >>> .el-table__header th .cell {
  line-height: 20px;
}
.stat-detail-like-table >>> .el-table__row td {
  height: 42px;
}

.dp-right > .toolbar {
  position: relative;
  z-index: 10;
  pointer-events: auto;
}
</style>
